// @ts-check
/** @jsx jsx */
/** @jsxFrag React.Fragment */
import {
  BookmarkIcon,
  EditIcon,
  ExportIcon,
  Text,
  Flex,
  Box,
  Stack,
  P,
  SemiTitle,
  Title,
} from '@bottlebooks/gatsby-theme-base';
import { Trans } from '@lingui/macro';
import React from 'react';
import { jsx } from 'theme-ui';

export default function FeatureOverview(rest) {
  return (
    <Box {...rest}>
      <Title sx={{ flexGrow: 1, marginBottom: 3 }}>
        <Trans>Create your personal tasting booklet</Trans>
      </Title>

      <P>
        <Trans>
          Personalize your visit to be as productive and enjoyable as possible.
        </Trans>
      </P>

      <>
        <Stack spacing={2} as={SemiTitle} direction="row" alignItems="center">
          <BookmarkIcon
            variant="filled"
            size="smallMedium"
            sx={{ color: 'primary' }}
          />
          <Box>
            <Trans>My bookmarks</Trans>
          </Box>
        </Stack>
        <P>
          <Trans>
            Click the bookmark icons to add exhibitors and products to your
            list.
          </Trans>
        </P>

        <SemiTitle>
          <ExportIcon size="smallMedium" sx={{ marginRight: 3 }} />
          <Trans>Tasting booklet</Trans>
        </SemiTitle>
        <P>
          <Trans>
            Create and print your personalized tasting booklet to take with you
            on the event – your bookmarked exhibitors and wines only, and a
            floor plan to guide you through the event.
          </Trans>
        </P>

        <Stack spacing={2} as={SemiTitle} direction="row" alignItems="center">
          <EditIcon size="smallMedium" sx={{ color: 'primary' }} />
          <Box>
            <Trans>Tasting notes</Trans>
          </Box>
        </Stack>
        <P>
          <Trans>
            Add tasting notes on your smartphone at the event, and export them
            when you get home.
          </Trans>
        </P>
      </>
    </Box>
  );
}
